<style scoped>
label {
  font-weight: 600;
  font-size: 13px;
  color: #7a7a7a;
  text-transform: capitalize;
  margin-bottom: 2px;
}
p {
  border-radius: 3px;
  color: #535353;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 2px;
}
.dashed-border-bottom {
  border-bottom: 1px dashed #dddddd;
  padding: 0;
}
</style>
<style>
.equation-structure .katex-display .katex .mathnormal,
.equation-structure .katex-display .katex {
 
  font-weight: 700 !important;
  font-size: 13px !important;
  color: #6b6b6b;
}
.equation-structure .katex-display .base {
  padding-left: 5px;
}
.equation-structure .eq-editor {
  min-height: 34px !important;
}
.equation-viewer .katex-display {
  display: flex;
  margin: 0;
}
.equation-viewer .ML__textarea{
 display: none !important;
}
.equation-viewer .sm{
  font-size:16px;
}
.equation-viewer .md{
  font-size:20px;
}
math-field:focus-within {
  outline: none;
}

</style>
<template>
  <div class="equation-viewer">
    <div v-if="value == '-'">{{ value }}</div>
    <div v-else>
      <math-field :class="'math-field '+size" read-only style="display:inline-block;font-style: normal;--caret: 53;">
        {{ value }}
      </math-field>
    </div>
  </div>
</template>
<script>
import "mathlive/dist/mathlive.min.mjs";
import "mathlive/dist/mathlive-fonts.css";
import "mathlive/dist/mathlive-static.css";

export default {
  components: {
    
  },
  props: {
    value: {
      type: String,
    },
    size: {
      type: String,
      default: 'md'
    },
  },
  
  data() {
    return {
      formula:
        "\\begin{aligned} P~Salinakes &=\\frac{JPMoTK}{JPM_{15-49}} x 100\\% \\\\ \\\\ P~Salifaskes &=\\frac{JPSalifaskes}{JPM_{15-49}} x 100\\% \\end{aligned}\\\\ \\\\ \\begin{aligned} \\texttt{Keterangan} \\\\ P~Salinakes &: \\texttt{Proporsi perempuan pernah kawin umur 15-49 tahun yang proses melahirkan terakhirnya ditolong oleh tenaga kesehatan terlatih}\\\\ P~Salifaskes &: \\texttt{Persentase perempuan pernah kawin umur 15-49 tahun yang proses melahirkan terakhirnya di fasilitas kesehatan}\\\\ JPMoTK &: \\texttt{Jumlah perempuan pernah kawin umur 15-49 tahun yang pernah melahirkan dan ditolong oleh tenaga kesehatan terlatih dalam dua tahun terakhir}\\\\ JPSalifaskes &: \\texttt{Jumlah perempuan pernah kawin umur 15-49 tahun yang proses melahirkan terakhirnya di fasilitas kesehatan}\\\\ JPM_{15-49} &: \\texttt{Jumlah perempuan pernah kawin umur 15-49 tahun yang pernah melahirkan dalam dua tahun terakhir} \\end{aligned}",
    };
  },
};
</script>